import React, { useEffect, useState } from "react";
import Breadcrump from "../../Components/Breadcrump";
import CategoryCard from "./Card";
import categoryApi from "../../api/categoryApi";

function CategoryListPage() {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    try {
      const res = await categoryApi.list();

      if (res.code === 200) {
        setCategory(res.data?.category || []);
      }
    } catch (err) {
      console.error("Category List API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrump title={"All Categories"} />

      <section className="py-5 bg-white">
        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <p>Loading...</p>
            </div>
          ) : category && category.length > 0 ? (
            <div className="row g-3">
              {category.map((cat) => (
                <div className="col-lg-3 col-md-4 col-6 mb-2" key={cat._id}>
                  <CategoryCard item={cat} />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <p>No Categories Found</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default CategoryListPage;
